class ShippingMethodController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'shippingMethod'
		'priceRegions'
		'vatRates'
		'providers'
		'Guid'
		'ShopRepository'
		'ShippingMethodRepository'
		'ShippingInformationRepository'
		'ConfigurationService'
		'ShippingInformationService'
		'BACKEND_SHIPPING_METHOD_ENTITY_TYPE'
		'BACKEND_PRODUCT_ENTITY_TYPE'
		'BACKEND_PRODUCT_DATA_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'general.shipping_method'
		@mainCrud.isNewEntity = !@shippingMethod.id?
		@selectedPriceRegionId = null
		@shippingInformation = []
		@shops = []
		@isVatRateEnabled = @ConfigurationService.isEnabled('Shared.Setting.VatRate.Enabled')

		@filter =
			page_size: @ShippingInformationRepository.pageSize
			count: 0
			page: 1

		@shippingMethodTypes = [
			{
				id: @BACKEND_SHIPPING_METHOD_ENTITY_TYPE.DROP_SHOP
				name: @translate('general.shipping_method.type.DropShopShippingMethod')
			}
			{
				id: @BACKEND_SHIPPING_METHOD_ENTITY_TYPE.PARCEL_SHOP
				name: @translate('general.shipping_method.type.ParcelShopShippingMethod')
			}
			{
				id: @BACKEND_SHIPPING_METHOD_ENTITY_TYPE.SHIP_TO_CUSTOMER
				name: @translate('general.shipping_method.type.ShipToCustomerShippingMethod')
			}
		]

		if @priceRegions.length == 1
			@selectedPriceRegionId = @priceRegions[0].id

		if !@mainCrud.isNewEntity
			@mainCrud.entityTitle = @shippingMethod.name

			if @shippingMethod.shops.length > 0
				query = @ShopRepository.createQuery()
				query.criteria 'id', 'IN', @shippingMethod.shops.join()

				@ShopRepository
					.findByQuery query
					.then (response) =>
						@shops = response.data
		else
			@mainCrud.entityTitle = 'general.shipping_method.new'
			@shippingMethod =
				entity_type: @BACKEND_SHIPPING_METHOD_ENTITY_TYPE.SHIP_TO_CUSTOMER

		@initializeProduct()
		@initializeProviders()

		@mainCrud.tabs = [
			{
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'general.shipping_information'
				disabled: @mainCrud.isNewEntity
				selector: '#tab-shipping-information'
			}
		]
		@search(1, true)

	initializeProviders: ->
		for provider in @providers
			provider.name = @translate('general.shipping_method.provider.type.' + provider.entity_type)

	initializeProduct: ->
		if @shippingMethod.product?
			product = @shippingMethod.product
		else
			product =
				id: @Guid.generate()

		product.name = @shippingMethod.name
		product.entity_type = @BACKEND_PRODUCT_ENTITY_TYPE.SHIPPING

		if product.product_data?
			@selectedPriceRegionId = product.product_data[0].price_region_id
		else
			product.product_data = []
			product.product_data[0] =
				variable_price: false
				cost_price: 0
				retail_price: 0
				price_region_id: @priceRegions[0].id
				unit_id: 'pc'

		product.product_data[0].entity_type = @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA

		@shippingMethod.product = product

	save: ->
		@mainCrud.saving = true

		shopsList = _.pluck(@shops, 'id')

		@shippingMethod.product.name = @shippingMethod.name
		@shippingMethod.product.description = @shippingMethod.description
		@shippingMethod.product.product_data[0].price_region_id = @selectedPriceRegionId
		@shippingMethod.shops = shopsList
		@shippingMethod.product.shops = shopsList

		@ShippingMethodRepository
			.save @shippingMethod, @mainCrud.isNewEntity
			.then (response) =>
				@shippingMethod = response.data

				@afterSave response
			.catch (result) =>
				@handleErrors result

	delete: ->
		@deleteEntity @ShippingMethodRepository, @shippingMethod

	search: (page = 1, withCounts = false) ->
		@filter.page = page
		@filter.shipping_method_id = @shippingMethod.id

		@ShippingInformationService
			.search @filter, withCounts
			.then (entities) =>
				@shippingInformation = entities

	findShops: (searchString) ->
		query = @ShopRepository.createQuery()
		query.criteria 'name', 'LIKE', searchString

		return @ShopRepository.findByQuery query
